import React, { useState } from 'react';
import RichTextEditor, { EditorValue, ToolbarConfig } from 'react-rte';
import { FormContext, FormItem } from '@digital/ui';
import './custom.css'

const defaultToolbarConfig = {
    // Conferir: https://github.com/sstur/react-rte/blob/master/src/lib/EditorToolbarConfig.js
    display: [
        'INLINE_STYLE_BUTTONS',
        // 'BLOCK_ALIGNMENT_BUTTONS',
        'BLOCK_TYPE_BUTTONS',
        // 'BLOCK_TYPE_DROPDOWN',
        // 'HISTORY_BUTTONS',
    ],
    INLINE_STYLE_BUTTONS: [
        { label: 'Bold', style: 'BOLD', className: 'icon-custom icon-bold-custom' },
        { label: 'Italic', style: 'ITALIC', className: 'icon-custom icon-italic-custom' },
        { label: 'Underline', style: 'UNDERLINE', className: 'icon-custom icon-underline-custom' },
    ],
    BLOCK_TYPE_DROPDOWN: [
        { label: 'Normal', style: 'unstyled' },
        { label: 'Heading Large', style: 'header-one' },
        { label: 'Heading Medium', style: 'header-two' },
        { label: 'Heading Small', style: 'header-three' },
    ],
    BLOCK_TYPE_BUTTONS: [
        { label: 'UL', style: 'unordered-list-item', className: 'icon-custom icon-unordered-list-custom' },
        { label: 'OL', style: 'ordered-list-item', className: 'icon-custom icon-ordered-list-custom' },
    ],
    BLOCK_ALIGNMENT_BUTTONS: [
        { label: 'Align Left', style: 'ALIGN_LEFT' },
        { label: 'Align Center', style: 'ALIGN_CENTER' },
        { label: 'Align Right', style: 'ALIGN_RIGHT' },
        { label: 'Align Justify', style: 'ALIGN_JUSTIFY' },
    ],
} as ToolbarConfig;

interface Props {
    disabled?: boolean;
    readonly?: boolean;
    name: string
    label: string
    span?: 2 | 1 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | undefined
    initialValue: string
}

const FormRichText = ({
    name,
    label,
    span,
    disabled = false,
    readonly = false,
    initialValue = ""
}: Props) => {
    const [rteDescricao, setRteDescricao] = useState<EditorValue>(RichTextEditor.createEmptyValue());
    const [initialSet, setInitialSet] = useState(false)

    return (
        <FormContext.Consumer>
            {({ formProps }) => {
                if (initialSet === false && initialValue !== undefined) {
                    let initial = RichTextEditor.createValueFromString(initialValue, 'html')
                    if (initial.toString("html") !== rteDescricao.toString("html")) {
                        setRteDescricao(initial)
                        setInitialSet(true)
                    }
                }

                return (
                    <FormItem name={name} label={label} span={span} >

                        <RichTextEditor
                            readOnly={readonly}
                            disabled={disabled}
                            rootStyle={disabled ? { background: 'whitesmoke' } : {}}
                            toolbarConfig={defaultToolbarConfig}
                            value={rteDescricao}
                            onChange={(value: EditorValue) => {
                                setRteDescricao(value);
                                if (formProps) {
                                    formProps.setFieldValue(name, value.toString('html'))
                                }
                            }}
                        />
                    </FormItem>
                )
            }
            }
        </FormContext.Consumer>
    )
}
export default FormRichText;